const POWER_TYPE_TILE_CONFIGS = [
  {
    label: 'offerWizard.stepPowerType.gruenstrom',
    value: 'gruenstrom',
    iconComponent: 'GruenstromIcon',
    urlValue: 'Gruenstrom',
  },
  {
    label: 'offerWizard.stepPowerType.graustrom',
    value: 'graustrom',
    iconComponent: 'GraustromIcon',
    urlValue: 'Graustrom',
  },
];

export default POWER_TYPE_TILE_CONFIGS;
